<script setup lang="ts">
import { normalizeFieldText } from '~/composables/useCustomFields'

const route = useRoute()
const rawName = decodeURIComponent(String(route.params.name || ''))
const page = computed(() => Math.max(1, Number(route.query.page || 1)))

const blogApi = useBlogApi()
const siteData = await useSiteData()
const siteBaseUrl = resolveSiteBaseUrl(siteData?.setting?.customFields)
const tags = await blogApi.getTagCloud()
const tag = tags.find(item => item.slug === rawName || item.name === rawName)
const tagName = tag?.name || rawName

const { data } = await useAsyncData(
  () => `tag:${tagName}:${page.value}`,
  () => blogApi.getContentMetaList({ page: page.value, pageSize: 10, type: 'post', tag: tagName }),
  { watch: [page] }
)

const siteName = normalizeFieldText(siteData?.setting?.customFields, 'siteName')

useSeoMeta({
  title: `#${tagName} - ${siteName}`,
  description: `标签 ${tagName} 的文章列表`,
  ogTitle: `#${tagName} - ${siteName}`,
  ogDescription: `标签 ${tagName} 的文章列表`
})

useHead({
  link: [{ rel: 'canonical', href: `${siteBaseUrl}${route.path}` }]
})
</script>

<template>
  <section>
    <div class="card header-card">
      <h1><i class="fa-solid fa-hashtag" aria-hidden="true" />{{ tagName }}</h1>
      <p>标签文章 {{ data?.total || 0 }} 篇</p>
    </div>

    <template v-if="(data?.list || []).length">
      <BlogPostCard v-for="item in data?.list || []" :key="item.ID" :item="item" />
      <BlogPager :page="page" :page-size="data?.pageSize || 10" :total="data?.total || 0" />
    </template>

    <div v-else class="empty-card">该标签暂无文章</div>
  </section>
</template>

<style scoped>
.header-card {
  padding: 20px;
  margin-bottom: 14px;
}

h1 {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: var(--heading-title-size);
}

p {
  margin-top: 8px;
  color: var(--text-soft);
}
</style>
